import { NavLink, Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";

const DashboardSidebar = ({ navItems, footerLinks, sidebarOpen, onClose, onLogout }) => (
  <>
    <div
      className={`dashboard-sidebar-backdrop ${sidebarOpen ? "open" : ""}`}
      onClick={onClose}
      aria-hidden="true"
    />
    <aside className={`dashboard-sidebar ${sidebarOpen ? "open" : ""}`}>
      <div className="dashboard-sidebar__brand">
        <Link to={navItems[0]?.to || "/"}>
          <img src="https://i.ibb.co/SywHnkP/Frame-1-1.png" alt="SmartTrans" />
        </Link>
      </div>
      <nav className="dashboard-sidebar__nav" onClick={onClose}>
        {navItems.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `dashboard-sidebar__link${isActive ? " active" : ""}`
            }
          >
            <Icon aria-hidden="true" />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="dashboard-sidebar__footer">
        {footerLinks?.map(({ to, label }) => (
          <Link key={to} to={to}>
            <FiExternalLink /> {label}
          </Link>
        ))}
        {onLogout && (
          <button type="button" onClick={onLogout}>
            Log out
          </button>
        )}
      </div>
    </aside>
  </>
);

export default DashboardSidebar;
